import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { getId, usePermissions } from "../../user/User"
import UserDetailView from "./UserDetailView"

const UserCreate = () => {
    const navigate = useNavigate()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.user !== undefined && !permissions.user) {
            toast.error("You don't have permission to create users!")
            navigate("/")
        }
    }, [permissions])

    const [id, setId] = useState(null)
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const { permissions: userPermissions, setPermissions: setUserPermissions } = usePermissions(id)
    
    return <UserDetailView id={id} setId={setId}
        name={name} setName={setName}
        email={email} setEmail={setEmail}
        password={password} setPassword={setPassword}
        userPermissions={userPermissions} setUserPermissions={setUserPermissions}
    />
}
   
export default UserCreate